<template>
  <div>
    <el-dialog title="选择统计的二维码" :visible.sync="dialog.seen" size="small" top="10%">
      <el-row>
        <el-col :span="6">
          <selecQqrLabelList></selecQqrLabelList>
        </el-col>
        <el-col :span="18">
          <router-view :dialog="dialog"></router-view>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>
 <script type="text/css" scoped>
import $ from 'jquery'
import selecQqrLabelList from './selectQrLabelList.vue'
export default {
  props: ['dialog'],
  components: {
    selecQqrLabelList
  },
  mounted () {
    // this.$router.push('/analysis/scan/labelid/all')
  }
}
</script>
